// @ts-nocheck
import type * as __TypedOpenapi from "./schemas.types.js";

import { z } from "zod";

// <Schemas>
export type ABool = __TypedOpenapi.Schemas.ABool;
export const ABool = z.enum(["none", "yes", "no"]);

export type AEcoModClass = __TypedOpenapi.Schemas.AEcoModClass;
export const AEcoModClass = z.enum([
  "none",
  "1A1",
  "1A2",
  "1A3",
  "1B1",
  "1B2",
  "1B3",
  "1B4",
  "1C1",
  "2A1",
  "2A2",
  "2A3",
  "2B1",
  "2C1",
  "2C2",
  "2D1",
  "2D2",
  "2D3",
  "2E1",
  "2E2",
  "3A1",
  "3A2",
  "3A3",
  "3B1",
  "3B2",
  "3B3",
  "3C1",
  "3C2",
  "4A1",
  "4B1",
  "5A1",
  "5A2",
  "6A1",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
]);

export type AKilosOrPercent = __TypedOpenapi.Schemas.AKilosOrPercent;
export const AKilosOrPercent = z.enum(["none", "kg", "percent"]);

export type ASupClass = __TypedOpenapi.Schemas.ASupClass;
export const ASupClass = z.enum([
  "none",
  "S1A1",
  "S1A2",
  "S1B1",
  "S2A1",
  "S2A2",
  "S2A3",
  "S3A1",
  "S3A2",
  "S3B1",
  "S3B2",
  "S4A1",
]);

export type AReusableClass = __TypedOpenapi.Schemas.AReusableClass;
export const AReusableClass = z.enum(["none", "first_use", "reuse"]);

export type ASecondaryMaterial = __TypedOpenapi.Schemas.ASecondaryMaterial;
export const ASecondaryMaterial = z.enum(["none", "1", "2", "3", "4", "5", "6"]);

export type AReportRowValue = __TypedOpenapi.Schemas.AReportRowValue;
export const AReportRowValue = z
  .object({
    ecomod_class: AEcoModClass,
    sup_class: ASupClass,
    business_use: ABool,
    reusable_class: AReusableClass,
    packaged_abroad: ABool,
    value: z.number().nullable(),
    secondary_material_type: ASecondaryMaterial,
    secondary_material_value: z.number().nullable(),
    secondary_material_value_type: AKilosOrPercent,
    empty_cup: ABool,
  })
  .partial();

export type AbstractProduct = __TypedOpenapi.Schemas.AbstractProduct;
export const AbstractProduct = z.object({
  identifier: z.string().nullable(),
  name: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  blobUrl: z.string().nullable().optional(),
  family: z.string().nullable(),
  packageRowsAssociation: z.string().nullable().optional(),
  internalReference: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  updated: z.iso.datetime().nullable().optional(),
  created: z.iso.datetime().nullable().optional(),
  ean: z.string().nullable().optional(),
  responsibleToReport: z.boolean().nullable().optional(),
  modelReverseAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
});

export type Action = __TypedOpenapi.Schemas.Action;
export const Action = z.enum(["change", "create", "delete"]);

export type Country = __TypedOpenapi.Schemas.Country;
export const Country = z
  .object({
    id: z.number().int().nullable(),
    nameFi: z.string().max(90).nullable(),
    nameSv: z.string().max(90).nullable(),
    nameEn: z.string().max(90).nullable(),
    iso2Abbreviation: z.string().min(2).max(2).nullable(),
    iso3Abbreviation: z.string().min(3).max(3).nullable(),
    isEU: z.boolean(),
  })
  .partial();

export type Address = __TypedOpenapi.Schemas.Address;
export const Address = z
  .object({
    id: z.number().int().nullable(),
    companyId: z.number().int().nullable(),
    organizationId: z.number().int().nullable(),
    addressLine: z.string().nullable(),
    addressLine2: z.string().nullable(),
    city: z.string().nullable(),
    postCode: z.string().nullable(),
    country: Country,
  })
  .partial();

export type AuthenticationRequest = __TypedOpenapi.Schemas.AuthenticationRequest;
export const AuthenticationRequest = z.object({ email: z.email().min(1), password: z.string().min(8) });

export type ChangePasswordRequest = __TypedOpenapi.Schemas.ChangePasswordRequest;
export const ChangePasswordRequest = z.object({
  userId: z.number().int(),
  changePasswordToken: z.string().nullable().optional(),
  newPassword: z.string().min(8).nullable(),
  newPasswordRetyped: z.string().min(8).nullable(),
});

export type CompanyIdentifierType = __TypedOpenapi.Schemas.CompanyIdentifierType;
export const CompanyIdentifierType = z
  .object({
    id: z.number().int().nullable(),
    identifierFi: z.string().nullable(),
    identifierSv: z.string().nullable(),
    identifierEn: z.string().nullable(),
  })
  .partial();

export type CompanyIdentifier = __TypedOpenapi.Schemas.CompanyIdentifier;
export const CompanyIdentifier = z.object({
  id: z.number().int().nullable().optional(),
  identifierType: CompanyIdentifierType,
  text: z.string().nullable(),
});

export type LanguageEnum = __TypedOpenapi.Schemas.LanguageEnum;
export const LanguageEnum = z.union([z.literal(0), z.literal(1), z.literal(2)]);

export type VatType = __TypedOpenapi.Schemas.VatType;
export const VatType = z.union([z.literal(0), z.literal(1), z.literal(2)]);

export type InvoicingInformation = __TypedOpenapi.Schemas.InvoicingInformation;
export const InvoicingInformation = z
  .object({
    id: z.number().int().nullable(),
    companyName: z.string().nullable(),
    businessIdentifier: z.string().nullable(),
    ovtNumber: z.string().nullable(),
    operator: z.string().nullable(),
    email: z.string().nullable(),
    address: Address,
    invoiceReference: z.string().nullable(),
    invoiceLanguage: LanguageEnum,
    vatType: VatType,
  })
  .partial();

export type Organization = __TypedOpenapi.Schemas.Organization;
export const Organization = z.object({
  id: z.number().int().nullable().optional(),
  organizationName: z.string().max(125).nullable(),
  addresses: z.array(Address).nullable().optional(),
  invoicingInformation: InvoicingInformation.optional(),
  blobUrl: z.string().nullable().optional(),
});

export type InvoicingTypeEnum = __TypedOpenapi.Schemas.InvoicingTypeEnum;
export const InvoicingTypeEnum = z.enum([
  "YEAR_ESTIMATE_QUARTERLY",
  "YEAR_ESTIMATE_MONTHLY",
  "QUARTERLY",
  "MONTHLY",
  "YEAR",
]);

export type CompanyInvoicingType = __TypedOpenapi.Schemas.CompanyInvoicingType;
export const CompanyInvoicingType = z
  .object({
    id: z.number().int().nullable(),
    companyId: z.number().int(),
    year: z.number().int(),
    invoicingType: InvoicingTypeEnum,
  })
  .partial();

export type Company = __TypedOpenapi.Schemas.Company;
export const Company = z.object({
  id: z.number().int().nullable().optional(),
  companyName: z.string().nullable(),
  contractStartDate: z.iso.datetime().nullable().optional(),
  contractEndDate: z.iso.datetime().nullable().optional(),
  country: Country.optional(),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  blobUrl: z.string().nullable().optional(),
  identifiers: z.array(CompanyIdentifier).nullable().optional(),
  addresses: z.array(Address).nullable().optional(),
  organizations: z.array(Organization).nullable().optional(),
  invoicingInformation: InvoicingInformation.optional(),
  companyInvoicingTypes: z.array(CompanyInvoicingType).nullable().optional(),
});

export type Permission = __TypedOpenapi.Schemas.Permission;
export const Permission = z.object({ id: z.number().int(), name: z.string().nullable() });

export type CompanyRights = __TypedOpenapi.Schemas.CompanyRights;
export const CompanyRights = z.object({
  companyId: z.number().int(),
  organizationId: z.number().int().nullable().optional(),
  userId: z.number().int(),
  permissions: z.array(Permission).nullable().optional(),
});

export type Configuration = __TypedOpenapi.Schemas.Configuration;
export const Configuration = z.object({
  id: z.number().int().nullable().optional(),
  key: z.string().nullable(),
  value: z.string().nullable(),
});

export type Cycle = __TypedOpenapi.Schemas.Cycle;
export const Cycle = z.union([z.literal(0), z.literal(1), z.literal(2)]);

export type EcoModUnit = __TypedOpenapi.Schemas.EcoModUnit;
export const EcoModUnit = z.union([z.literal(0), z.literal(1), z.literal(2)]);

export type EcoModClass = __TypedOpenapi.Schemas.EcoModClass;
export const EcoModClass = z
  .object({
    id: z.number().int().nullable(),
    code: z.string().max(255).nullable(),
    nameFi: z.string().max(255).nullable(),
    nameEn: z.string().max(255).nullable(),
    nameSv: z.string().max(255).nullable(),
    secondary: z.boolean(),
    secondaryNameFi: z.string().max(255).nullable(),
    secondaryNameEn: z.string().max(255).nullable(),
    secondaryNameSv: z.string().max(255).nullable(),
    valueUnit: EcoModUnit,
  })
  .partial();

export type Email = __TypedOpenapi.Schemas.Email;
export const Email = z
  .object({
    id: z.number().int().nullable(),
    created: z.iso.datetime(),
    modified: z.iso.datetime(),
    createdBy: z.number().int(),
    modifiedBy: z.number().int(),
    sender: z.string().nullable(),
    body: z.string().nullable(),
    receiverId: z.number().int().nullable(),
    subject: z.string().nullable(),
  })
  .partial();

export type EmailAddress = __TypedOpenapi.Schemas.EmailAddress;
export const EmailAddress = z.object({ email: z.string().nullable(), isValidated: z.boolean().optional() });

export type Entity = __TypedOpenapi.Schemas.Entity;
export const Entity = z.enum(["organization", "person", "unknown"]);

export type EntraAuthenticationCode = __TypedOpenapi.Schemas.EntraAuthenticationCode;
export const EntraAuthenticationCode = z.object({ code: z.string().nullable() });

export type ExcelUploadResponse = __TypedOpenapi.Schemas.ExcelUploadResponse;
export const ExcelUploadResponse = z
  .object({
    reportId: z.number().int().nullable(),
    createdReportRows: z.number().int(),
    updatedReportRows: z.number().int(),
    errors: z.array(z.string()).nullable(),
    warnings: z.array(z.string()).nullable(),
  })
  .partial();

export type ForgottenPasswordRequest = __TypedOpenapi.Schemas.ForgottenPasswordRequest;
export const ForgottenPasswordRequest = z.object({ email: z.email().nullable() });

export type Model = __TypedOpenapi.Schemas.Model;
export const Model = z.object({
  identifier: z.string().nullable(),
  name: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  blobUrl: z.string().nullable().optional(),
  family: z.string().nullable(),
  packageRowsAssociation: z.string().nullable().optional(),
  internalReference: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  updated: z.iso.datetime().nullable().optional(),
  created: z.iso.datetime().nullable().optional(),
  ean: z.string().nullable().optional(),
  responsibleToReport: z.boolean().nullable().optional(),
  modelReverseAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
  productAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
  packageAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
  modelAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
});

export type PackageRows = __TypedOpenapi.Schemas.PackageRows;
export const PackageRows = z.object({
  identifier: z.string().nullable(),
  name: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  family: z.string().nullable(),
  synkkaImported: z.boolean().nullable().optional(),
  updated: z.iso.datetime().nullable().optional(),
  created: z.iso.datetime().nullable().optional(),
  rowValues: z.array(AReportRowValue).nullable().optional(),
  price: z.number().nullable().optional(),
  productReverseAssociations: z.array(z.string()).nullable().optional(),
  modelReverseAssociations: z.array(z.string()).nullable().optional(),
  packageReverseAssociations: z.array(z.string()).nullable().optional(),
});

export type Product = __TypedOpenapi.Schemas.Product;
export const Product = z.object({
  identifier: z.string().nullable(),
  name: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  blobUrl: z.string().nullable().optional(),
  family: z.string().nullable(),
  packageRowsAssociation: z.string().nullable().optional(),
  internalReference: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  updated: z.iso.datetime().nullable().optional(),
  created: z.iso.datetime().nullable().optional(),
  ean: z.string().nullable().optional(),
  responsibleToReport: z.boolean().nullable().optional(),
  modelReverseAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
  packageAssociation: z.string().nullable().optional(),
});

export type Package = __TypedOpenapi.Schemas.Package;
export const Package = z.object({
  identifier: z.string().nullable(),
  name: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  blobUrl: z.string().nullable().optional(),
  family: z.string().nullable(),
  packageRowsAssociation: z.string().nullable().optional(),
  internalReference: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  updated: z.iso.datetime().nullable().optional(),
  created: z.iso.datetime().nullable().optional(),
  productReverseAssociations: z.array(z.string()).nullable().optional(),
  modelReverseAssociations: z.record(z.string(), z.number().int()).nullable().optional(),
});

export type FullModelInfoNew = __TypedOpenapi.Schemas.FullModelInfoNew;
export const FullModelInfoNew = z.object({
  model: Model,
  packageRows: PackageRows.optional(),
  parentModels: z.array(Model).nullable().optional(),
  childModels: z.array(Model).nullable().optional(),
  products: z.array(Product).nullable().optional(),
  packages: z.array(Package).nullable().optional(),
});

export type FullProductInfoNew = __TypedOpenapi.Schemas.FullProductInfoNew;
export const FullProductInfoNew = z.object({
  product: Product,
  package: Package.optional(),
  packageRows: PackageRows.optional(),
  parentModels: z.array(Model).nullable().optional(),
});

export type PermissionEnum = __TypedOpenapi.Schemas.PermissionEnum;
export const PermissionEnum = z.union([
  z.literal(94),
  z.literal(100),
  z.literal(200),
  z.literal(300),
  z.literal(400),
  z.literal(900),
]);

export type GrantPermissionRequest = __TypedOpenapi.Schemas.GrantPermissionRequest;
export const GrantPermissionRequest = z
  .object({
    userId: z.number().int(),
    permissions: z.array(PermissionEnum).nullable(),
    companyId: z.number().int(),
    organizationId: z.number().int().nullable(),
  })
  .partial();

export type Status = __TypedOpenapi.Schemas.Status;
export const Status = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]);

export type InvoiceTypeEnum = __TypedOpenapi.Schemas.InvoiceTypeEnum;
export const InvoiceTypeEnum = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
  z.literal(8),
  z.literal(9),
  z.literal(10),
  z.literal(11),
  z.literal(12),
  z.literal(13),
  z.literal(14),
  z.literal(15),
  z.literal(16),
  z.literal(17),
  z.literal(18),
  z.literal(19),
  z.literal(20),
  z.literal(21),
  z.literal(22),
]);

export type Invoice = __TypedOpenapi.Schemas.Invoice;
export const Invoice = z
  .object({
    id: z.number().int().nullable(),
    companyId: z.number().int().nullable(),
    reportId: z.number().int().nullable(),
    reportIds: z.array(z.number().int()).nullable(),
    externalId: z.number().int().nullable(),
    deadlineDateTime: z.string().nullable(),
    totalAmount: z.number().nullable(),
    paidAmount: z.number().nullable(),
    createdDateTime: z.string().nullable(),
    paidDateTime: z.string().nullable(),
    status: Status,
    invoiceType: InvoiceTypeEnum,
  })
  .partial();

export type Message = __TypedOpenapi.Schemas.Message;
export const Message = z
  .object({
    id: z.number().int().nullable(),
    created: z.iso.datetime(),
    modified: z.iso.datetime(),
    createdBy: z.number().int(),
    modifiedBy: z.number().int(),
    sender: z.string().nullable(),
    body: z.string().nullable(),
  })
  .partial();

export type PersonNames = __TypedOpenapi.Schemas.PersonNames;
export const PersonNames = z.object({
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  name: z.string().nullable(),
});

export type PhoneNumber = __TypedOpenapi.Schemas.PhoneNumber;
export const PhoneNumber = z.object({ number: z.string().nullable(), isValidated: z.boolean().optional() });

export type NewUserRequest = __TypedOpenapi.Schemas.NewUserRequest;
export const NewUserRequest = z.object({
  id: z.number().int().nullable().optional(),
  created: z.iso.datetime().optional(),
  modified: z.iso.datetime().optional(),
  createdBy: z.number().int().optional(),
  modifiedBy: z.number().int().optional(),
  names: PersonNames,
  email: EmailAddress,
  phoneNumber: PhoneNumber.optional(),
  language: z.string().nullable().optional(),
  externalIds: z.array(z.number().int()).nullable().optional(),
  password: z.string().min(8).nullable(),
});

export type PipeBase = __TypedOpenapi.Schemas.PipeBase;
export const PipeBase = z.object({ id: z.number().int(), name: z.string().nullable() }).partial();

export type PipeMeta = __TypedOpenapi.Schemas.PipeMeta;
export const PipeMeta = z.object({ action: Action, entity: Entity });

export type PipeBasePipeWebhookResponse = __TypedOpenapi.Schemas.PipeBasePipeWebhookResponse;
export const PipeBasePipeWebhookResponse = z.object({ meta: PipeMeta, data: PipeBase.optional() });

export type Suffix = __TypedOpenapi.Schemas.Suffix;
export const Suffix = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);

export type PriceInfo = __TypedOpenapi.Schemas.PriceInfo;
export const PriceInfo = z.object({ amount: z.number().nullable(), suffix: Suffix }).partial();

export type Price = __TypedOpenapi.Schemas.Price;
export const Price = z
  .object({
    id: z.number().int().nullable(),
    year: z.number().int().nullable(),
    name: z.string().nullable(),
    ecomodClassId: z.number().int().nullable(),
    supClassId: z.number().int().nullable(),
    priceInfo: z.array(PriceInfo).nullable(),
  })
  .partial();

export type ReportStatus = __TypedOpenapi.Schemas.ReportStatus;
export const ReportStatus = z.union([z.literal(1), z.literal(2), z.literal(3)]);

export type ReportType = __TypedOpenapi.Schemas.ReportType;
export const ReportType = z.union([z.literal(1), z.literal(2), z.literal(3)]);

export type SupClass = __TypedOpenapi.Schemas.SupClass;
export const SupClass = z
  .object({
    id: z.number().int().nullable(),
    code: z.string().max(255).nullable(),
    nameFi: z.string().max(255).nullable(),
    nameEn: z.string().max(255).nullable(),
    nameSv: z.string().max(255).nullable(),
  })
  .partial();

export type ReusableClass = __TypedOpenapi.Schemas.ReusableClass;
export const ReusableClass = z.union([z.literal(1), z.literal(2)]);

export type SecValueType = __TypedOpenapi.Schemas.SecValueType;
export const SecValueType = z.union([z.literal(1), z.literal(2)]);

export type ReportRowValue = __TypedOpenapi.Schemas.ReportRowValue;
export const ReportRowValue = z.object({
  id: z.number().int().nullable().optional(),
  ecoModulationClass: EcoModClass.optional(),
  supClass: SupClass.optional(),
  supPlasticWeight: z.number().nullable().optional(),
  supReusablePlasticWeight: z.number().nullable().optional(),
  isEmptyCup: z.boolean(),
  businessUse: z.boolean(),
  reusableClass: ReusableClass.optional(),
  packagedAbroad: z.boolean(),
  value: z.number().nullable().optional(),
  secMaterial: EcoModClass.optional(),
  secValue: z.number().nullable().optional(),
  secValueType: SecValueType.optional(),
});

export type ReportRow = __TypedOpenapi.Schemas.ReportRow;
export const ReportRow = z
  .object({
    id: z.number().int().nullable(),
    ean: z.string().max(20).nullable(),
    name: z.string().max(255).nullable(),
    akeneoId: z.string().max(255).nullable(),
    amount: z.number().int(),
    active: z.boolean(),
    values: z.array(ReportRowValue).nullable(),
    internalReference: z.string().nullable(),
    comment: z.string().nullable(),
    created: z.iso.datetime(),
    modified: z.iso.datetime(),
  })
  .partial();

export type ReportInternalStatus = __TypedOpenapi.Schemas.ReportInternalStatus;
export const ReportInternalStatus = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]);

export type Report = __TypedOpenapi.Schemas.Report;
export const Report = z.object({
  id: z.number().int().nullable().optional(),
  created: z.iso.datetime().optional(),
  modified: z.iso.datetime().optional(),
  createdBy: z.number().int().optional(),
  modifiedBy: z.number().int().optional(),
  companyId: z.number().int().optional(),
  organizationId: z.number().int().nullable().optional(),
  year: z.number().int().optional(),
  quarter: z.number().int().nullable().optional(),
  month: z.number().int().nullable().optional(),
  comment: z.string().nullable().optional(),
  reportStatus: ReportStatus.optional(),
  reportType: ReportType,
  rows: z.array(ReportRow).nullable().optional(),
  internalReportStatus: ReportInternalStatus.optional(),
  approvedAt: z.iso.datetime().nullable().optional(),
  approvedBy: z.number().int().nullable().optional(),
  invoiceId: z.number().int().nullable().optional(),
  sentBy: z.number().int().nullable().optional(),
  sentAt: z.iso.datetime().nullable().optional(),
});

export type ReportComment = __TypedOpenapi.Schemas.ReportComment;
export const ReportComment = z
  .object({
    id: z.number().int().nullable(),
    created: z.iso.datetime(),
    modified: z.iso.datetime(),
    createdBy: z.number().int(),
    modifiedBy: z.number().int(),
    sender: z.string().nullable(),
    body: z.string().nullable(),
    reportId: z.number().int().nullable(),
    replyId: z.number().int().nullable(),
  })
  .partial();

export type ReportCycle = __TypedOpenapi.Schemas.ReportCycle;
export const ReportCycle = z
  .object({
    id: z.number().int().nullable(),
    companyId: z.number().int().nullable(),
    year: z.number().int().nullable(),
    cycle: Cycle,
    created: z.iso.datetime(),
    modified: z.iso.datetime(),
  })
  .partial();

export type ReportOverview = __TypedOpenapi.Schemas.ReportOverview;
export const ReportOverview = z
  .object({ internalMessagesCount: z.number().int(), report: Report, company: Company })
  .partial();

export type SearchProduct = __TypedOpenapi.Schemas.SearchProduct;
export const SearchProduct = z
  .object({
    identifier: z.string().nullable(),
    name: z.string().nullable(),
    companyId: z.string().nullable(),
    image: z.string().nullable(),
    family: z.string().nullable(),
    ean: z.string().nullable(),
    responsibleToReport: z.boolean().nullable(),
    internalReference: z.string().nullable(),
    comment: z.string().nullable(),
    updated: z.iso.datetime().nullable(),
    created: z.iso.datetime().nullable(),
  })
  .partial();

export type Token = __TypedOpenapi.Schemas.Token;
export const Token = z.object({
  id: z.number().int().nullable().optional(),
  access_token: z.string().nullable(),
  token_type: z.string().nullable().optional(),
  scope: z.string().nullable().optional(),
  expires_in: z.number().int().optional(),
});

export type User = __TypedOpenapi.Schemas.User;
export const User = z.object({
  id: z.number().int().nullable().optional(),
  created: z.iso.datetime().optional(),
  modified: z.iso.datetime().optional(),
  createdBy: z.number().int().optional(),
  modifiedBy: z.number().int().optional(),
  names: PersonNames,
  email: EmailAddress,
  phoneNumber: PhoneNumber.optional(),
  language: z.string().nullable().optional(),
  externalIds: z.array(z.number().int()).nullable().optional(),
});

// </Schemas>
